import { render, staticRenderFns } from "./edit-translation.vue?vue&type=template&id=2c54c602&scoped=true"
import script from "./edit-translation.vue?vue&type=script&lang=js"
export * from "./edit-translation.vue?vue&type=script&lang=js"
import style0 from "./edit-translation.vue?vue&type=style&index=0&id=2c54c602&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../.worktrees/accreditations-staging-e2e-fix/frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c54c602",
  null
  
)

export default component.exports